import { NgIf, NgIfContext } from '@angular/common';
import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RbacServiceInterface } from '../../../core/services/rbac/rbac-service.interface';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[rbac]' })
export class RbacDirective<T = unknown> extends NgIf {
  constructor(
    @Inject('RbacServiceInterface') private rbacService: RbacServiceInterface,
    viewContainer: ViewContainerRef,
    templateRef: TemplateRef<NgIfContext<T>>
  ) {
    super(viewContainer, templateRef);
  }
  @Input()
  public set rbac(permission: string | string[]) {
    this.ngIf = this.rbacService.can(permission);
  }
  @Input()
  public set rbacElse(templateRef: TemplateRef<NgIfContext<T>> | null) {
    this.ngIfElse = templateRef;
  }
  @Input()
  public set rbacThen(templateRef: TemplateRef<NgIfContext<T>> | null) {
    this.ngIfThen = templateRef;
  }
}
